import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link, Navigate, useParams } from 'react-router-dom';
import PublicPageShell from '../components/PublicPageShell';
import PageMeta from '../components/PageMeta';
import { blogPosts, formatBlogDate } from '../content/blogPosts';

function BlogPostPage() {
  const { slug } = useParams();
  const post = blogPosts.find((candidate) => candidate.slug === slug);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <PublicPageShell>
      <PageMeta
        title={`${post.title} | Zaphar`}
        description={post.excerpt}
      />
      <article className="mx-auto max-w-3xl py-12 sm:py-20">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-stone-300 transition hover:text-stone-50">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" />
          All posts
        </Link>
        <div className="mt-9 flex flex-wrap items-center gap-2 text-sm text-stone-400">
          <span className="rounded-full bg-amber-300/10 px-3 py-1 font-medium text-amber-200">{post.category}</span>
          <time dateTime={post.publishedAt}>{formatBlogDate(post.publishedAt)}</time>
          <span aria-hidden="true">·</span>
          <span>{post.readTime}</span>
        </div>
        <h1 className="mt-6 text-4xl font-semibold leading-tight tracking-tight text-stone-50 sm:text-6xl">{post.title}</h1>
        <p className="mt-6 text-lg leading-8 text-stone-300">{post.excerpt}</p>

        <div className="mt-12 border-t border-white/10 pt-4">
          {post.content.map((section) => (
            <section key={section.heading} className="py-6">
              <h2 className="text-2xl font-semibold tracking-tight text-stone-50">{section.heading}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph} className="mt-4 text-base leading-8 text-stone-300">{paragraph}</p>
              ))}
            </section>
          ))}
        </div>
      </article>
    </PublicPageShell>
  );
}

export default BlogPostPage;
